import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { Message } from '@naf/input';
import { spacing, breakpoints } from '@naf/theme';

export const BundleWrapper = styled.div``;

export const Title = styled(Text)`
  margin-top: 0;
  margin-bottom: ${spacing.space32};
`;

export const MembershipBoxWrapper = styled.div`
  margin-bottom: ${spacing.space64};

  @media (max-width: ${breakpoints.s}) {
    margin-bottom: ${spacing.space32};
  }
`;

export const StyledMessage = styled(Message)`
  margin-top: ${spacing.space16};
`;
